/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  ChecklistDetailsDto,
  ChecklistDto,
  ChecklistElementType,
  ChecklistExportToOfficeDto,
  ChecklistImportAvailabilityDto,
  ChecklistImportFromMasterZoneDto,
  ChecklistSectionDto,
} from './mobile-checklists.model';

export const MobChecklistMapper = entity<ChecklistDto>({});
export const ChecklistExportToOfficeMapper = entity<ChecklistExportToOfficeDto>({});
export const ChecklistImportFromMasterZoneMapper = entity<ChecklistImportFromMasterZoneDto>({});
export const ChecklistImportAvailabilityMapper = entity<ChecklistImportAvailabilityDto>({});
export const MobChecklistDetailMapper = entity<ChecklistDetailsDto>({
      checklistElements: arrayOf(subentity<ChecklistSectionDto>({
        elementType: enumeration(ChecklistElementType),
      })),
  });
